

<div class="modal-lg">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Asignar Colaborador</h4>
    <button type="button" class="close text-primary" aria-label="Close" (click)="activeModal.close()">
      <i class="fas fa-times-circle"></i>
    </button>
  </div>
  <div class="modal-body">
    <div class="col-md-12 pb-4 pl-4 pr-4 pt-0">
      <div class="col-md-12">
        @if (collaboratorLoading) {
          <div class="d-flex justify-content-center">
            <table class="table-borderless" style="table-layout: fixed; width: 100%;">
              <div class="spinner-border text-primary" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </table>
          </div>
        }

        @if ( !collaboratorLoading) {
          <form autocomplete="off" [formGroup]="formCollaborator"
            >
            <div class=" w-100">
              <div class="row mb-1">
                <div class="col-md-10">
                  <label class="text-form">Usuario</label>
                  <select class="form-control" name="idsContracts" data-cy="select-simple" formControlName="userid">
                    <option value="">Seleccionar</option>
                    @for (colab of usersSuscribed; track colab) {
                      <option [value]="colab.id">
                        {{ colab.name }}
                      </option>
                    }
                  </select>
                  @if (formCollaborator.controls.userid.touched &&
                    formCollaborator.controls.userid.errors?.required) {
                    <div class="text-danger list-unstyled">
                      Usuario es requerido
                    </div>
                  }
                </div>
              </div>
            </div>
            <div class="w-100">
              <div class="row">
                <div class="col-md-10">
                  <label for="" class="text-form">
                    Motivo o razón
                  </label>
                  <textarea class="form-control style-textarea" rows="2" cols="40" formControlName="reason"
                  maxlength="250"></textarea>
                </div>
              </div>
            </div>
          </form>
        }
      </div>
    </div>
  </div>
  <div class="modal-footer col-md-10">
    <button type="button" class="
          btn btn-outline-primary
          bg-white
          rounded-pill
          text-dark
          px-4
          font-weight-bold
        " (click)="activeModal.dismiss('Cross click')">
      Cancelar
    </button>
    <button type="button" class="
          btn btn-outline-primary
          bg-white
          rounded-pill
          text-dark
          px-4
          font-weight-bold
        " (click)="onSubmit()"  [disabled]="!formCollaborator.valid" data-cy="submit">
      Guardar
    </button>
  </div>
</div>


